function trimTrailingSlash(value) {
  return String(value || '').replace(/\/+$/, '');
}

function getDefaultApiBaseUrl() {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return 'http://localhost:5000/api';
    }
  }

  return 'https://api.me-guide.com/api';
}

export const API_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_API_URL || getDefaultApiBaseUrl()
);

export const API_ORIGIN = API_BASE_URL.replace(/\/api$/i, '');
export const SITE_ORIGIN = trimTrailingSlash(process.env.REACT_APP_SITE_URL || '');
